import { render, staticRenderFns } from "./productionStageMonthlyUnitsChartWidget.vue?vue&type=template&id=428bc4ae&"
import script from "./productionStageMonthlyUnitsChartWidget.vue?vue&type=script&lang=js&"
export * from "./productionStageMonthlyUnitsChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports